<template>
  <div class="atom-subnav-anchor">
    <a
      class="atom-subnav-anchor__link"
      @click="scrollToAnchor(data.id)"
      @keydown.enter="scrollToAnchor(data.id)"
    >
      {{ data.text }}
    </a>
  </div>
</template>

<script setup>
const props = defineProps({
    data: {
        type: Object,
        default: () => {},
    },
    scrollDuration: {
        type: String,
        default: '0.5',
    },
    scrollOffset: {
        type: Number,
        default: 110,
    },
});

/*
  Scroll to anchor
*/
const { gsapScrollTo } = useGsap();
const scrollToAnchor = (anchor) => {
    gsapScrollTo(window, {
        duration: props.scrollDuration,
        ease: 'Circ.easeInOut',
        scrollTo: { y: `#${anchor}`, offsetY: props.scrollOffset },
    });
};
</script>

<style lang="scss">
.atom-subnav-anchor {
    @include typo-size('nav');
    @include typo-font('bold');

    @include fluid('margin-right', 22px, 42px);

    &:first-child {
        @include fluid('padding-left', 0px, 53px);

    }

    &:last-child {
        @include fluid('padding-right', 0px, 53px);
    }

    .atom-subnav-anchor__link {
        position: relative;
        color: $C_PRIMARY;
        cursor: pointer;
        transition: color 0.1s ease-in-out;
        white-space: nowrap;

        &:hover {
            color: $C_SECONDARY;
        }
    }
}
</style>
